import { useEffect, useRef, useState } from "react";
import { useStyles } from "../../Styles/styles";
import { styled } from "styled-components";
import { FormControl } from "@material-ui/core";
import moment from "moment";
import SingleDropDown from "../SingleDropDown";
import { ID } from "../../types";
import WrappedKeyboardDateTimePicker from "../WrappedKeyboardDateTimePicker";
import { parseDateFlexible } from "../../utils/utils";

const passFailOptions = [
  { id: "1", name: "Pass" },
  { id: "0", name: "Fail" },
];

const DropDownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 8px;
  justify-content: center;
`;

const CalibrationContainer = styled.div`
  border: 1px solid grey;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

interface CalibrationProps {
  id: ID;
  locked: boolean;
  dateValue: string;
  dateName: string;
  handleChange: (name: string, value: any, type?: string) => void;
  setPausePolling?: (pause: boolean) => void;
  userRoles: string[];
  dropDownArr?: {
    stateName: string;
    value: string;
    helperText?: string;
  }[];
  title: string; // This is to allow any valid React node as the title
  [key: string]: any; // For ...props
}

const Calibration: React.FC<CalibrationProps> = ({
  id,
  locked,
  dateValue,
  dateName,
  handleChange,
  setPausePolling,
  userRoles,
  dropDownArr = [],
  title,
  ...props
}) => {
  const classes = useStyles();
  const inputLabel = useRef<HTMLLabelElement>(
    null
  ) as React.RefObject<HTMLLabelElement>;
  const [labelWidth, setLabelWidth] = useState<number>(0);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, [inputLabel]);

  const handleCalibrationChange = (name: string, value: any, type?: string) => {
    if (type === "date") {
      handleChange(name, value, "date");
    } else {
      handleChange(name, value.id); // Assuming the default is handling the dropdown ID.
    }
  };

  return (
    <>
      {title}
      <CalibrationContainer>
        <FormControl variant="standard" className={classes.formControl}>
          <WrappedKeyboardDateTimePicker
            dataCy={`calibration-datetime-picker-${id}`}
            id={`calibration-datetime-picker-${id}`}
            disabled={locked}
            clearable={true}
            showTodayButton={true}
            label="Time Tested"
            // name="date"
            name={dateName}
            InputLabelProps={{ shrink: true }}
            value={parseDateFlexible(dateValue)}
            onBlur={() => setPausePolling && setPausePolling(false)}
            onFocus={() => setPausePolling && setPausePolling(true)}
            onChange={(
              _value: any, // unused, so prefix with _
              name: string,
              date: moment.Moment
            ) => {
              handleChange(name, date, "date");
            }}
            format="MM/DD/YYYY HH:mm"
            ampm={false}
            onDoubleClick={null}
          />
        </FormControl>
        {dropDownArr.map((dd, index) => {
          const { stateName, value, helperText } = dd;
          return (
            <DropDownWrapper key={dd.stateName + "-" + index}>
              <SingleDropDown
                handleChange={(
                  e: React.ChangeEvent<{ name?: string; value: ID }>
                ) => handleCalibrationChange(e.target.name!, e.target.value)}
                stateName={stateName}
                value={
                  value ? { id: value, name: +value ? "Pass" : "Fail" } : ""
                }
                options={passFailOptions}
                helperText={helperText}
                inputLabel={inputLabel}
                labelWidth={labelWidth}
                userRoles={userRoles}
                {...props}
              />
            </DropDownWrapper>
          );
        })}
      </CalibrationContainer>
    </>
  );
};

export default Calibration;
